import { render, staticRenderFns } from "./aiDialog.vue?vue&type=template&id=489bc992&scoped=true"
import script from "./aiDialog.vue?vue&type=script&lang=js"
export * from "./aiDialog.vue?vue&type=script&lang=js"
import style0 from "./aiDialog.vue?vue&type=style&index=0&id=489bc992&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489bc992",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('489bc992')) {
      api.createRecord('489bc992', component.options)
    } else {
      api.reload('489bc992', component.options)
    }
    module.hot.accept("./aiDialog.vue?vue&type=template&id=489bc992&scoped=true", function () {
      api.rerender('489bc992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Navbar/aiDialog.vue"
export default component.exports